// src/screens/Reconcile/ReconcileVariance.js
import React, { useContext, useEffect } from 'react';
import CountContext from '../../context/CountContext.js';

export default function ReconcileVariance({ onNext, onBack }) {
  const { state, dispatch } = useContext(CountContext);
  const {
    rolls,
    report: { totalCharges, totalSales, giftCardSold, giftCardPayment },
    tipBucket: { coins: tipBucketCoins, bills: tipBucketBills },
    drawerCoins,
    bills,
    thresholds: { starterCash },
    vendorPayouts,
    overageApplied
  } = state;
  const effectiveSales = totalSales;
  const giftCardPaymentWhole = Math.floor(giftCardPayment);
  const giftPaymentCents = Number(((giftCardPayment || 0) % 1).toFixed(2));
  

  // 1) Total coin pool: rolls + tip-bucket coins + drawer coins
  const rollsValue =
    rolls.quarters * 10 +
    rolls.dimes * 5 +
    rolls.nickels * 2 +
    rolls.pennies * 0.5;
  const coinTotalPrecise = rollsValue + tipBucketCoins + drawerCoins;
  const changeTotal = Math.floor(coinTotalPrecise);

  // 2) Total bills value
  const billsValue =
    bills.ones * 1 +
    bills.fives * 5 +
    bills.tens * 10 +
    bills.twenties * 20 +
    bills.fifties * 50 +
    bills.hundreds * 100;

  // 3) Vendor payouts
  const vendorTotal = vendorPayouts.reduce((sum, v) => sum + (v.amount || 0), 0);

  // 4) Net cash: change + bills − starter − vendor payouts − un‑redeemed gift‑cards
  const netCash = changeTotal + billsValue - starterCash + vendorTotal - giftCardSold + giftCardPaymentWhole;


  // 5) Grand total including credit-card charges
  const grandTotal = netCash + totalCharges;

  // 6) Variance against adjusted POS Total Sales
  const variance = grandTotal - effectiveSales + giftPaymentCents;
  // ←— INSERT THE ROLLBACK EFFECT HERE:
  useEffect(() => {
    if (state.salesAdjusted && variance < 0) {
      dispatch({ type: 'UNDO_REPORT_ADJUSTMENT' });
      alert(
        `You’re still $${Math.abs(variance).toFixed(2)} short. ` +
        `Rolling back your sales adjustment so you can enter missing vendor payouts.`
      );
    }
  }, [state.salesAdjusted, variance, dispatch]);


  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg" >
      <h2 className="text-xl font-semibold mb-4">Check Variance</h2>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <div className="text-sm text-gray-600">Adjusted POS Total</div>
          <div className="text-lg font-bold">${effectiveSales.toFixed(2)}</div>
        </div>
        <div>
          <div className="text-sm text-gray-600">Cash + Credit</div>
          <div className="text-lg font-bold">${grandTotal.toFixed(2)}</div>
        </div>
        <div>
          <div className="text-sm text-gray-600">Variance</div>
          <div
            className={`text-lg font-bold ${variance >= 0 ? 'text-green-600' : 'text-red-600'
              }`}
          >
            ${variance >= 0 ? '+' : ''}{variance.toFixed(2)}
          </div>
        </div>
      </div>
      {/* …the rest of your JSX… */}

      {variance > 0 && (
        <div className="mt-6">
          <p className="mb-4 text-xl font-bold">
            Bank is <span className="text-2xl font-extrabold">${variance.toFixed(2)}</span> over.<br />
            Pull that amount in highest‑denomination bills and add it to your Total Tips that were already set aside.
          </p>

          {!overageApplied ? (
            <button
              onClick={() => {
                dispatch({ type: 'APPLY_OVERAGE', payload: variance });
                onNext();
              }}
              className="px-4 py-2 bg-blue-500 text-white rounded"
            >
              Apply Overage to Tips
            </button>
          ) : (
            <button
              onClick={onNext}
              className="px-4 py-2 bg-green-500 text-white rounded"
            >
              Continue
            </button>
          )}
        </div>
      )}



      {
        variance === 0 && (
          <div className="mt-6">
            <p className="mb-4 text-green-600">
              Perfect! No overage or shortage—bank matches adjusted sales.
            </p>
            <button
              onClick={onNext}
              className="px-4 py-2 bg-green-500 text-white rounded"
            >
              Continue
            </button>
          </div>
        )
      }

      {
        variance < 0 && (
          <div className="mt-6 text-red-600">
            Bank is <strong>${Math.abs(variance).toFixed(2)}</strong> short—please investigate.
          </div>
        )
      }

      <div className="mt-6 flex justify-between">
        <button onClick={onBack} className="px-4 py-2 bg-gray-300 rounded">
          Back
        </button>
      </div>
    </div >
  );
}
